module.exports = __webpack_public_path__ + "static/zorbo-feeb9bc96a4cd300b2aa9665f5ba4484.png";